<ng-container *ngIf="course">
  <ng-container *ngIf="course.syllabus; else emptySyllabus">
    <ng-container>
      <app-syllabus-edit-button *appAuthorize="course.owner" class="float-right" [ngClass]=AppConfig.theme>
        <button mat-fab color="accent" class="p-fixed" [routerLink]="['edit']">
          <mat-icon>edit</mat-icon>
        </button>
      </app-syllabus-edit-button>
    </ng-container>

      <ng-container *ngIf="course.syllabus.mainTitleBackgroundImg; else NonMainTitleBackgorundImg">
        <div class="main-intro w-100 h-100"
             [ngStyle]="{'background':'url('+ course.syllabus.mainTitleBackgroundImg + ') top center no-repeat'}">
          <div class="background-cover-layer-black w-100 h-100">
            <div class="main-text text-center w-100 p-relative px-5">
              <h1>{{ course.name }}</h1>
              <h4 *ngIf="course.syllabus.subTitle" [innerHtml]="course.syllabus.subTitle"></h4>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #NonMainTitleBackgorundImg>
        <div class="main-intro w-100 d-block"
             [ngStyle]="{'background':'url('+ course.syllabus.mainTitleBackgroundImg + ')'}"
             [ngClass]=AppConfig.theme>
          <div [ngClass]="course.syllabus.mainTitleBackgroundImg ? 'background-cover-layer-white' : ''">
            <div class="main-text colorBackground px-5">
              <h1>{{ course.name }}</h1>
              <h4 *ngIf="course.syllabus.subTitle" [innerHtml]="course.syllabus.subTitle"></h4>
            </div>
          </div>
        </div>
      </ng-template>

    <ng-container *ngIf="course.syllabus.purpose">
      <div class="page-block-a">
        <h5>Introduce This Course</h5>
        <h1 class="mt-3 mb-5">What is Purpose?</h1>

        <div class="flex-container" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <img fxFlex="50%" fxFlex.sm="90%" fxFlex.xs="90%" src="/assets/syllabus/bracket.png" />
        </div>

        <h5 class="my-5">
          <p [innerHtml]="course.syllabus.purpose"></p>
        </h5>
        <div class="flex-container" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <img fxFlex="50%" fxFlex.sm="90%" fxFlex.xs="90%" src="/assets/syllabus/bracket-bottom.png" />
        </div>
      </div>

      <app-center-divider></app-center-divider>
    </ng-container>


    <ng-container *ngIf="course.syllabus.advantageTitle">
      <div class="page-block-b w-100 my-3">
        <h1 class="my-5 pt-5 px-5" [innerHtml]="course.syllabus.advantageTitle"></h1>
        <div class="flex-container my-5 py-5" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutWrap="wrap">

          <div class="block-c-card p-2" fxFlex.lg="27%" fxFlex="27%" fxFlex.sm="80%">
            <mat-card>
              <img mat-card-image [src]=course.syllabus.advantage1Img>
              <mat-card-content>
                <h3 class="pt-3" [innerHtml]="course.syllabus.advantage1Title"></h3>
                <p class="mt-4" [innerHtml]="course.syllabus.advantage1Exp">
                </p>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="block-c-card p-2" fxFlex.lg="27%" fxFlex="27%" fxFlex.sm="80%">
            <mat-card>
              <img mat-card-image [src]=course.syllabus.advantage2Img>
              <mat-card-content>
                <h3 class="pt-3" [innerHtml]="course.syllabus.advantage2Title"></h3>
                <p class="mt-4" [innerHtml]="course.syllabus.advantage2Exp">
              </mat-card-content>
            </mat-card>
          </div>

          <div class="block-c-card p-2" fxFlex.lg="27%" fxFlex="27%" fxFlex.sm="80%">
            <mat-card>
              <img mat-card-image [src]=course.syllabus.advantage1Img>
              <mat-card-content>
                <h3 class="pt-3" [innerHtml]="course.syllabus.advantage3Title"></h3>
                <p class="mt-4" [innerHtml]="course.syllabus.advantage3Exp">
              </mat-card-content>
            </mat-card>
          </div>

        </div>
      </div>

      <app-center-divider></app-center-divider>
    </ng-container>

    <ng-container *ngIf="course.syllabus.curriculum">
      <div class="page-block-c my-5 px-3 pb-5 w-100">
        <h5 class="margin-center text-center">온/오프라인 피드백이 진행되는</h5>
        <h1 class="mt-3 pb-5 text-center">Curriculum</h1>
        <div class="flex-container" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <div class="timeline w-80 p-relative education mt-5" fxFlex.lg="80%" fxFlex.md="80%" fxFlex.sm="95%">
            <div class="row">
              <div class="col-md-12">
                <ng-container *ngFor="let unit of course.syllabus.curriculum">
                  <app-syllabus-curriculum [curriculumUnit]="unit"></app-syllabus-curriculum>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-center-divider></app-center-divider>
    </ng-container>

    <ng-container *ngIf="course.syllabus.numberingList">
      <div class="page-block-c my-5 px-3 pb-5 w-100">
        <h5 class="margin-center text-center">꾸준한 피드백을 통해 변화하는</h5>
        <h1 class="mt-3 pb-5 text-center">강의방식</h1>

        <div class="flex-container" fxLayoutAlign="center center" fxLayout.xs="column" fxLayoutWrap="wrap">
          <div fxFlex.lg="80%" fxFlex.md="80%" fxFlex.sm="95%">
            <ng-container *ngFor="let unit of course.syllabus.numberingList">
              <app-syllabus-curriculum-numbering-list [item]="unit"></app-syllabus-curriculum-numbering-list>
            </ng-container>
          </div>
        </div>
      </div>

      <app-center-divider></app-center-divider>
    </ng-container>

    <ng-container *ngIf="course.syllabus.additionalTitle">
      <div class="page-block-d w-100 mb-5 py-5">
        <h1 class="pb-5 mt-4 text-center px-5" [innerHtml]="course.syllabus.additionalTitle"></h1>
        <div class="flex-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <div class="block-d-card p-2" fxFlex="27%" fxFlex.sm="80%">
            <mat-card [ngClass]=AppConfig.theme>
              <mat-card-content>
                <h3 class="pt-3" [innerHtml]="course.syllabus.addCard1Title"></h3>
                <p class="mt-4" [innerHtml]="course.syllabus.addCard1Exp">
                </p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="block-d-card p-2" fxFlex="27%" fxFlex.sm="80%">
            <mat-card [ngClass]=AppConfig.theme>
              <mat-card-content>
                <h3 class="pt-3" [innerHtml]="course.syllabus.addCard2Title"></h3>
                <p class="mt-4" [innerHtml]="course.syllabus.addCard2Exp">
                </p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="block-d-card p-2" fxFlex="27%" fxFlex.sm="80%">
            <mat-card [ngClass]=AppConfig.theme>
              <mat-card-content>
                <h3 class="pt-3" [innerHtml]="course.syllabus.addCard3Title"></h3>
                <p class="mt-4" [innerHtml]="course.syllabus.addCard3Exp">
                </p>
              </mat-card-content>
            </mat-card>

          </div>
        </div>
      </div>
      <app-center-divider></app-center-divider>
    </ng-container>

    <ng-container *ngIf="course.syllabus.instructorMsg">
      <div class="page-block-e py-5 mb-5">
        <h1 class="mt-2 mb-5 pb-5 px-5" [innerHtml]="course.syllabus.instructorMsgTitle"></h1>
        <div class="flex-container" fxLayout="row" fxLayout.xs="row" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <div class="block-quote" fxFlex="75%" fxFlex.sm="80%">
            <div class="block-img">
              <img class="img-circle" [src]="(course.ownerObservable | async)?.avatarUrl">
            </div>
            <div class="block-icon img-circle">
              <i class="fa fa-quote-left" aria-hidden="true"></i>
            </div>
            <h3 class="block-profile" [innerHtml]="course.syllabus.instructorName">
              <span>{{ course.syllabus.instructorPos }}</span>
            </h3>
            <blockquote [innerHtml]="course.syllabus.instructorMsg"></blockquote>
          </div>
        </div>
      </div>

      <app-center-divider></app-center-divider>
    </ng-container>

    <ng-container *ngIf="course.syllabus.recommenders">
      <div class="page-block-f py-5 mb-5">
        <h1 class="mt-2 mb-5 pb-5 px-5">이 강의를 먼저 수강한 분들이 추천합니다.</h1>

        <div class="flex-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutWrap="wrap">
          <div fxFlex="75%" fxFlex.sm="90%">
            <app-syllabus-recommenders [course]="course"></app-syllabus-recommenders>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="course.syllabus.hookMsg">
      <div class="hook-block" [ngClass]=AppConfig.theme>
        <h2 class="text-center" [innerHtml]="course.syllabus.hookMsg"></h2>
      </div>
    </ng-container>


    <ng-container *ngIf="course.syllabus.applyCard">
      <div class="page-block-g mt-5 py-3">
        <mat-card class="apply-card w-80 margin-center mt-5 mb-5 p-5" [ngClass]=AppConfig.theme>
          <mat-card-content>
           <p [innerHtml]="course.syllabus.applyCard"></p>
          </mat-card-content>
          <mat-card-actions align="end" [ngClass]=AppConfig.theme>
              <a mat-raised-button color="accent" href={{course.syllabus.applyUrl}} class="text-decoration-none"  target="_blank">수강신청</a>
          </mat-card-actions>
        </mat-card>
      </div>
    </ng-container>
  </ng-container>


  <ng-template #emptySyllabus>
    <h1 class="emptySyllabusMsg p-absolute w-100 text-center color-gray">현재 강의소개가 준비중입니다.</h1>
    <app-syllabus-add-button *appAuthorize="course.owner" class="float-right" [ngClass]=AppConfig.theme>
      <button mat-fab color="accent" class="p-fixed"(click)="createSyllabus()">
        <mat-icon>add</mat-icon>
      </button>
    </app-syllabus-add-button>
  </ng-template>

</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-detail/syllabus-detail.component.html